import React from "react";
import Todo from "../../../components/todo/Todo";
import Header from "../../../components/header/Header";

export default function Jobs() {
  return (
    <React.Fragment>
      <Header />
      <Todo />
    </React.Fragment>
  );
}
